<template>
    <div class="template">
      <navigation auth/>
    </div>
</template>

<script>
import consts from '@/consts'
import event from '@/services/event'
import logger from '@/services/logger'
import translation from '@/services/translation'
import router from '@/router'
import user from '@/services/user'

export default {
  data () {
    return {
      previous: null
    }
  },
  created () {
    logger.setFields({})
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previous = from
    })
  },
  beforeMount () {
    // Get updated rights
    user.me()
      .then(data => {
        // User doesn't have rights on web console
        if (!data || !data.rights || !data.rights.web_console) {
          // Redirect
          router.push({
            name: 'login',
            params: {
              no_web_console: true,
              ...this.previous.params
            }
          })
            .catch(err => { logger.error(err) })
          return
        }

        // Get rights
        const r = data.rights

        // Create event
        event.create()
          .then(data => {
            // Get query params
            var q = {}
            if (typeof this.previous.query.force_onboarding !== 'undefined') q.force_onboarding = this.previous.query.force_onboarding

            // Redirect
            router.push(translation.route({
              name: 'studio',
              params: {
                event_id: data.id,
                rights: r
              },
              query: q
            }))
              .catch(err => { logger.error(err) })
          })
          .catch(err => {
            // Process error
            var msg = this.$i18n.t('errors.default')
            if (err.isHTTP) {
              // Process error code
              switch (err.code) {
                case consts.error_codes.too_many_events:
                  // Redirect
                  router.push({
                    name: 'home',
                    params: {
                      too_many_events: true,
                      ...this.previous.params
                    },
                    query: this.previous.query
                  })
                    .catch(err => { logger.error(err) })
                  return
              }

              // Update message
              msg = err
            } else {
              // Log
              logger.error(err)
            }

            // Toast
            this.$parent.$parent.$refs.toaster.error(msg)
          })
      })
      .catch(err => {
        var msg = this.$i18n.t('errors.default')
        if (err.isHTTP) {
          msg = err
        } else {
          logger.error(err)
        }
        if (!err.noToast) this.$parent.$parent.$refs.toaster.error(msg)
      })
  }
}
</script>
